export const ALERTAFTEREMAILVERIFICATION = "ALERTAFTEREMAILVERIFICATION";
export const getAlertAfterEmailPop = (data) => {
    return {
        type: ALERTAFTEREMAILVERIFICATION,
        payload: data
    }
}